<div class="report-chart">
  <header class="chart-header">
    <div class="close" (click)="close()"></div>
    <div class="chart-title">
      <h2>{{chart.name}}</h2>
      <span class="subtitle">{{reportName}}<ng-container *ngIf="rangeLabel"> · {{rangeLabel}}</ng-container></span>
    </div>
    <div class="chart-actions">
      <div class="segmented" title="Chart type">
        <button class="segment" [class.active]="chartType === 'line'" (click)="setChartType('line')">Line</button>
        <button class="segment" [class.active]="chartType === 'bar'" (click)="setChartType('bar')">Bar</button>
      </div>
      <div class="segmented" *ngIf="seriesAvailable" [title]="'Split by ' + (seriesField?.name || chart.seriesPath)">
        <button class="segment" [class.active]="!bySeries" (click)="setBySeries(false)">Combined</button>
        <button class="segment" [class.active]="bySeries" (click)="setBySeries(true)">By {{seriesField?.name || chart.seriesPath}}</button>
      </div>
    </div>
  </header>

  <div class="chart-body">
    <aside class="field-panel">
      <div class="panel-title">Y Axis</div>
      <p class="hint" *ngIf="yOptions.length === 0">This report has no numeric fields to plot.</p>
      <div class="field-option" *ngFor="let option of yOptions" [class.on]="option.on">
        <app-toggle [checked]="option.on" (valueChanged)="toggleY(option, $event)"></app-toggle>
        <span class="name" (click)="toggleY(option, !option.on)">{{option.field.name}}</span>
        <span class="axis" *ngIf="option.on" [title]="option.field.calculated ? 'Ratio: recomputed per point from ' + option.field.formula : ''">{{isCurrency(option.field) ? '$' : '#'}}<ng-container *ngIf="option.field.calculated"> ÷</ng-container></span>
      </div>
      <div class="panel-footer">
        <div>X: {{xField?.name || chart.xPath}}<ng-container *ngIf="xIsDate"> by {{chart.xBucket || 'day'}}</ng-container></div>
        <div *ngIf="!loading">{{rowCount | rf: 'number'}} rows · {{pointCount | rf: 'number'}} points<ng-container *ngIf="bySeries"> · {{chartData.datasets.length}} series</ng-container></div>
      </div>
    </aside>

    <section class="canvas-area">
      <div class="state" *ngIf="loading">Loading chart data…</div>
      <div class="state" *ngIf="!loading && emptyMessage">{{emptyMessage}}</div>
      <div class="canvas-wrap" [class.hidden]="loading || emptyMessage">
        <canvas baseChart [type]="chartType" [data]="chartData" [options]="chartOptions"></canvas>
      </div>
    </section>
  </div>
</div>
